const config_settings = {
  "localhost:3003": {
    SERVER_URL: "https://dev-rw-api.yourinspection.app/public/index.php/api/",
    IR_URL: "https://develop.myinspection.report/",
    RW_URL: "https://develop.report-writer.yourinspection.app/",
    PORTAL_URL: "https://develop.palmtech.dev/",
    PORTAL_SERVER_URL: "https://dev-portal-api.yourinspection.app/public/index.php/api",
    AI_URL: "https://staging-genie-ai.inspectionsupport.com/api/gpt/upload-and-analyse/"
  },
  "localhost:3003": {
    SERVER_URL: "https://dev-rw-api.yourinspection.app/public/index.php/api/",
    IR_URL: "https://develop.myinspection.report/",
    RW_URL: "https://develop.report-writer.yourinspection.app/",
    PORTAL_URL: "https://develop.palmtech.dev/",
    PORTAL_SERVER_URL: "https://dev-portal-api.yourinspection.app/public/index.php/api",
    AI_URL: "https://staging-genie-ai.inspectionsupport.com/api/gpt/upload-and-analyse/"
  },
  "localhost:3001": {
    SERVER_URL: "https://int-rw-api.yourinspection.app/public/index.php/api/",
    IR_URL: "https://integration.myinspection.report/",
    PORTAL_URL: "https://integration.palmtech.dev/",
    RW_URL: "https://integration.report-writer.yourinspection.app/",
    PORTAL_SERVER_URL: "https://int-portal-api.yourinspection.app/public/index.php/api",
    AI_URL: "https://staging-genie-ai.inspectionsupport.com/api/gpt/upload-and-analyse/"
  },
  "develop.d1b2u24rehxcop.amplifyapp.com": {
    SERVER_URL: "https://dev-rw-api.yourinspection.app/public/index.php/api/",
    IR_URL: "https://develop.myinspection.report/",
    RW_URL: "https://develop.report-writer.yourinspection.app/",
    PORTAL_URL: "https://develop.palmtech.dev/",
    PORTAL_SERVER_URL: "https://dev-portal-api.yourinspection.app/public/index.php/api",
    AI_URL: "https://staging-genie-ai.inspectionsupport.com/api/gpt/upload-and-analyse/"
  },
  "develop.report-writer.yourinspection.app": {
    SERVER_URL: "https://dev-rw-api.yourinspection.app/public/index.php/api/",
    IR_URL: "https://develop.myinspection.report/",
    RW_URL: "https://develop.report-writer.yourinspection.app/",
    PORTAL_URL: "https://develop.palmtech.dev/",
    PORTAL_SERVER_URL: "https://dev-portal-api.yourinspection.app/public/index.php/api",
    AI_URL: "https://staging-genie-ai.inspectionsupport.com/api/gpt/upload-and-analyse/"
  },
  "integration.report-writer.yourinspection.app": {
    SERVER_URL: "https://int-rw-api.yourinspection.app/public/index.php/api/",
    IR_URL: "https://integration.myinspection.report/",
    RW_URL: "https://integration.report-writer.yourinspection.app/",
    PORTAL_URL: "https://integration.palmtech.dev/",
    PORTAL_SERVER_URL: "https://int-portal-api.yourinspection.app/public/index.php/api",
    AI_URL: "https://staging-genie-ai.inspectionsupport.com/api/gpt/upload-and-analyse/"
  },
  "staging.report-writer.yourinspection.app": {
    SERVER_URL: "https://stg-rw-api.yourinspection.app/public/index.php/api/",
    IR_URL: "https://staging.myinspection.report/",
    RW_URL: "https://staging.report-writer.yourinspection.app/",
    PORTAL_URL: "https://staging.palmtech.com/",
    PORTAL_SERVER_URL: "https://stg-portal-api.palmtech.com/public/index.php/api",
    AI_URL: "https://prod-genie-ai.inspectionsupport.com/api/gpt/upload-and-analyse/"
  },
  "report-writer.yourinspection.app": {
    SERVER_URL: "https://prod-rw-api.yourinspection.app/public/index.php/api/",
    IR_URL: "https://myinspection.report/",
    RW_URL: "https://report-writer.yourinspection.app/",
    PORTAL_URL: "https://portal.palmtech.com/",
    PORTAL_SERVER_URL: "https://prod-portal-api.palmtech.com/public/index.php/api",
    AI_URL: "https://prod-genie-ai.inspectionsupport.com/api/gpt/upload-and-analyse/"
  },
  "$PRID-wrw.palmtechpr.com": {
    SERVER_URL: "https://int-rw-api.yourinspection.app/public/index.php/api/",
    IR_URL: "https://integration.myinspection.report/",
    RW_URL: "https://integration.report-writer.yourinspection.app/",
    PORTAL_URL: "https://integration.palmtech.dev/",
    PORTAL_SERVER_URL: "https://int-portal-api.yourinspection.app/public/index.php/api",
    AI_URL: "https://staging-genie-ai.inspectionsupport.com/api/gpt/upload-and-analyse/"
 },
};

export default config_settings;